// value对应要传的参数
export const DEFAULT_INFO_MAP = [
  {
    value: 'project',
    text: 'Project Name',
  },
  {
    value: 'studio',
    text: 'Studio',
  },
  {
    value: 'milestone',
    text: 'Milestone',
  },
  {
    value: 'date',
    text: 'Milestone Date',
  },
];

export const MILESTONE_TYPE_MAP = {
  OFFCIAL_GATE_REVIEW: '1',
  ALL_MILESTONE: '2',
  LAUNCHING_TIME: '3',
};

export const MILESTONE_TYPE_MAP_NEW = {
  ALL_MILESTONE: '2',
  GR_MILESTONE: 'gr',
  CHECKIN_MILESTONE: 'check_in',
  LAUNCH_MILESTONE: 'launch',
  TEST_MILESTONE: 'test',
  OTHERS_MILESTONE: 'others',
};
